import { useTranslation } from "react-i18next";
import { useTheme } from "@/hooks/useTheme";

// PROP-210: i18n fallbacks for the tooltip — the en/zh `theme.title.*`
// keys override these; defaultValue keeps it working if a key is missing.
const TITLE_FALLBACK = {
  auto: "Theme: auto (follows system)",
  dark: "Theme: dark",
  light: "Theme: light",
} as const;

export function ThemeToggle({ className }: { className?: string }) {
  const { mode, cycle } = useTheme();
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={cycle}
      title={t(`theme.title.${mode}`, { defaultValue: TITLE_FALLBACK[mode] }) as string}
      className={`inline-flex h-7 w-7 items-center justify-center rounded-md border border-border text-text-muted transition hover:border-border-strong hover:text-text ${className ?? ""}`}
    >
      {mode === "dark"  && <MoonIcon />}
      {mode === "light" && <SunIcon />}
      {mode === "auto"  && <AutoIcon />}
    </button>
  );
}

function MoonIcon() {
  return (
    <svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <path
        d="M12 8.5A5.5 5.5 0 0 1 5.5 2a5.5 5.5 0 1 0 6.5 6.5z"
        stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  );
}

function SunIcon() {
  return (
    <svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <circle cx="7" cy="7" r="2.5" stroke="currentColor" strokeWidth="1.3" />
      <path
        d="M7 1v1.2M7 11.8V13M1 7h1.2M11.8 7H13M2.93 2.93l.85.85M10.22 10.22l.85.85M2.93 11.07l.85-.85M10.22 3.78l.85-.85"
        stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"
      />
    </svg>
  );
}

function AutoIcon() {
  return (
    <svg width={14} height={14} viewBox="0 0 14 14" fill="none">
      <circle cx="7" cy="7" r="5.2" stroke="currentColor" strokeWidth="1.3" />
      <path d="M7 1.8V7l3.2 3.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
